'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _AnimatedProperties = require('./AnimatedProperties');

var _AnimatorManager = require('./AnimatorManager');

var _Draggable = require('./Draggable');

var _Draggable2 = _interopRequireDefault(_Draggable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var nextId = 100;

var Layer = function (_React$Component) {
  _inherits(Layer, _React$Component);

  function Layer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Layer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Layer.__proto__ || Object.getPrototypeOf(Layer)).call.apply(_ref, [this].concat(args))), _this), _this._computedStyles = {}, _this.getID = function () {
      if (!_this._id) {
        _this._id = '' + nextId;
        nextId++;
      }
      return _this._id;
    }, _this.getComputedStyles = function () {
      return Object.assign({}, _this._computedStyles);
    }, _this._getTargetValues = function (obj) {
      return Object.keys(obj).reduce(function (acc, key) {
        acc[key] = (0, _AnimatedProperties.getTargetValue)(obj[key]);
        return acc;
      }, {});
    }, _this._handleTargetPropertyChange = function (updates, property, fromScalar, to) {
      if ((typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object') {
        if (to.type === 'animated') {
          if (fromScalar == null) {
            updates[property] = to.value;
          } else {
            // TODO: reuse previous animator if same config?
            var _animator = (0, _AnimatorManager.createAnimator)(_this, property, to.config);
            var onEnd = to.onEnd;

            _animator.start(fromScalar, to.value, function (value) {
              _this._applyUpdates(_defineProperty({}, property, value));
            }, function () {
              return _this._onAnimationEnd(onEnd);
            });
          }
        } else if (to.type === 'drag' && (!_this._draggable || !_this._draggable.isActive())) {
          _this._handleTargetPropertyChange(updates, property, fromScalar, to.value);
        }
      } else {
        (0, _AnimatorManager.removeAnimator)(_this, property);
        updates[property] = to;
      }
    }, _this._applyUpdates = function (updates) {
      if ((0, _AnimatedProperties.applyUpdates)(_this._layer, updates, _this._computedStyles)) {
        var _p = {
          x: _this._computedStyles.x,
          y: _this._computedStyles.y
        };
        if (_this._draggable && !_this._draggable.isActive()) {
          _this._draggable.setPoint(_p);
        }
        _this.props.onMove && _this.props.onMove(_p);
      }
    }, _this._onAnimationEnd = function (onEnd) {
      onEnd && onEnd();
      _this.props.onAnimationEnd && _this.props.onAnimationEnd();
    }, _this._updateDraggable = function (frame) {
      var x = frame.x,
          y = frame.y;

      var isDragX = (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x.type === 'drag';
      var isDragY = (typeof y === 'undefined' ? 'undefined' : _typeof(y)) === 'object' && y.type === 'drag';
      if (isDragX || isDragY) {
        var draggable = _this._getDraggable();
        draggable.setConfig('x', isDragX ? x.config || {} : null);
        draggable.setConfig('y', isDragY ? y.config || {} : null);
      } else if (_this._draggable) {
        _this._draggable.stop();
        _this._draggable = null;
      }
    }, _this._getDraggable = function () {
      if (!_this._draggable) {
        var draggable = new _Draggable2.default();
        draggable.start(_this._layer, _this._computedStyles, _this._onDragStart, _this._dragUpdater, _this._onDragRelease, _this._onDragEnd);
        _this._draggable = draggable;
      }
      return _this._draggable;
    }, _this._onDragStart = function () {
      (0, _AnimatorManager.removeAnimator)(_this, 'x');
      (0, _AnimatorManager.removeAnimator)(_this, 'y');
    }, _this._dragUpdater = function (p) {
      _this._applyUpdates({
        x: p.x,
        y: p.y
      });
      _this.props.onDrag && _this.props.onDrag(p);
    }, _this._onDragRelease = function (p) {
      _this.props.onDragRelease && _this.props.onDragRelease(p);
    }, _this._onDragEnd = function (p) {
      if (_this.props.onDragEnd) {
        _this.props.onDragEnd(p);
        // this allows clients to modify props on before resetting
        window.requestAnimationFrame(_this._resetPointAfterDrag);
      } else {
        _this._resetPointAfterDrag();
      }
    }, _this._resetPointAfterDrag = function () {
      var updates = {};
      _this._handleTargetPropertyChange(updates, 'x', _this._computedStyles.x, _this.props.frame.x);
      _this._handleTargetPropertyChange(updates, 'y', _this._computedStyles.y, _this.props.frame.y);
      _this._applyUpdates(updates);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Layer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          frame = _props.frame,
          style = _props.style;

      var updates = this._getTargetValues(frame);
      if (style) {
        updates = Object.assign({}, updates, this._getTargetValues(style));
      }
      this._applyUpdates(updates);
      this._updateDraggable(frame);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var animator = nextProps.animator,
          frame = nextProps.frame,
          style = nextProps.style;

      this._updateDraggable(frame);
      var nextValues = this._getTargetValues(frame);
      if (style) {
        nextValues = Object.assign({}, nextValues, this._getTargetValues(style));
      }
      var prevValues = this._getTargetValues(this.props.frame);
      if (this.props.style) {
        prevValues = Object.assign({}, prevValues, this._getTargetValues(this.props.style));
      }
      var differingProperties = (0, _AnimatedProperties.getDifferingProperties)(nextValues, prevValues);
      if (differingProperties.length > 0) {
        var updates = {};
        differingProperties.forEach(function (property) {
          var value = void 0;
          if (frame.hasOwnProperty(property)) {
            value = frame[property];
          } else {
            value = style && style[property];
          }
          _this2._handleTargetPropertyChange(updates, property, _this2._computedStyles[property], value);
        });
        this._applyUpdates(updates);
      }
    }

    /**
     * Resolve values to target scalars (e.g. Animated and Drag)
     * "Target" may not be the live value (e.g. in middle of drag or animation)
     */


    /**
     * Updates the passed updates map for given property and from/to values.
     * Should be called by properties that have changed target value.
     */


    /**
     * Applies updates to DOM and handles if point changed
     */

  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return _react2.default.Children.count(nextProps.children) > 0 || _react2.default.Children.count(this.props.children) > 0;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      (0, _AnimatorManager.removeAnimatorsForLayer)(this);
      if (this._draggable) {
        this._draggable.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          children = _props2.children,
          animator = _props2.animator,
          frame = _props2.frame,
          style = _props2.style,
          onMove = _props2.onMove,
          onDrag = _props2.onDrag,
          onDragRelease = _props2.onDragRelease,
          onDragEnd = _props2.onDragEnd,
          props = _objectWithoutProperties(_props2, ['children', 'animator', 'frame', 'style', 'onMove', 'onDrag', 'onDragRelease', 'onDragEnd']);

      return _react2.default.createElement(
        'div',
        Object.assign({}, props, { ref: function ref(c) {
            return _this3._layer = c;
          }, style: Styles.Layer }),
        children
      );
    }
  }]);

  return Layer;
}(_react2.default.Component);

exports.default = Layer;


var Styles = {
  Layer: {
    position: 'absolute',
    backgroundSize: 'cover',
    backgroundPosition: '50% 50%'
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/buttery/lib/Layer.js
// module id = 75
// module chunks = 0